<template>
  <spinner v-if="$apollo.loading" />
  <main v-else>
    <header>
      <img src="/assets/color-logo.svg" alt>
      <span>ID #{{ reportId }}</span>
    </header>
    <dl>
      <dt>Prodajno mjesto</dt>
      <dd>{{ seller.firstName }} {{ seller.lastName }}</dd>
      <dt>Datum i vrijeme izrade obračuna</dt>
      <dd>{{ formatDateTime(now) }}</dd>
    </dl>
    <h1>Obračun prodanih ulaznica OB-{{ reportId }}/{{ getYear(now) }}</h1>
    <p class="event-title">{{ seller.firstName }} {{ seller.lastName }}</p>
    <p class="sale-period">Za period od {{ formatDate(from) }} do {{ formatDate(to) }}</p>
    <table>
      <thead>
        <tr>
          <th>Br.</th>
          <th />
          <th>Event</th>
          <th>Naziv</th>
          <th>Jed. cijena</th>
          <th>Količina</th>
          <th>Ukupno</th>
          <th v-if="refundedOrders.length">Datum</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(order, index) in orders" :key="index" style="color: green">
          <td>{{ index + 1 }}.</td>
          <td />
          <td>{{ order.eventTitle }}</td>
          <td>{{ order.name }}</td>
          <td>{{ order.price }}&nbsp;EUR</td>
          <td>{{ order.count }}</td>
          <td>{{ order.totalPrice }}&nbsp;EUR</td>
          <td v-if="refundedOrders.length" />
        </tr>
        <tr
          v-for="(order, index) in refundedOrders"
          :key="orders.length + index + 1"
          style="color: red"
        >
          <td>{{ orders.length + index + 1 }}.</td>
          <td />
          <td>{{ order.eventTitle }}</td>
          <td>{{ order.name }}</td>
          <td>{{ order.price }}&nbsp;EUR</td>
          <td>-{{ order.count }}</td>
          <td>-{{ order.totalPrice }}&nbsp;EUR</td>
          <td v-if="refundedOrders.length">{{ formatDateTime(order.orderRefunded) }}</td>
        </tr>
        <tr
          v-for="(fee, index) in fixedFeeItems"
          :key="fee.name"
          style="color: green"
        >
          <td>{{ orders.length + refundedOrders.length + index + 1 }}.</td>
          <td />
          <td>{{ fee.eventTitle }}</td>
          <td>{{ fee.name }}</td>
          <td>{{ fee.singleItemPrice }}&nbsp;EUR</td>
          <td>{{ fee.count }}</td>
          <td>{{ fee.totalPrice }}&nbsp;EUR</td>
        </tr>
        <tr
          v-for="(fee, index) in tisakFeeItems"
          :key="fee.name"
          style="color: green"
        >
          <td>{{ orders.length + refundedOrders.length + fixedFeeItems.length + index + 1 }}.</td>
          <td />
          <td>{{ fee.eventTitle }}</td>
          <td>{{ fee.name }}</td>
          <td>{{ fee.singleItemPrice }}&nbsp;EUR</td>
          <td>{{ fee.count }}</td>
          <td>{{ fee.totalPrice }}&nbsp;EUR</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td
            :style="{
              color:
                totalSoldAmount + totalCoreEventFee + totalTisakFee >= 0 ? 'green !important' : 'red !important',
            }"
            colspan="5"
          >
            Sveukupno:
          </td>
          <td
            :style="{
              color:
                totalSoldAmount + totalCoreEventFee + totalTisakFee >= 0 ? 'green !important' : 'red !important',
            }"
          >
            {{ totalSoldCount }}
          </td>
          <td
            :style="{
              color:
                totalSoldAmount + totalCoreEventFee + totalTisakFee >= 0 ? 'green !important' : 'red !important',
            }"
          >
            {{ round(totalSoldAmount + totalCoreEventFee + totalTisakFee, 2) }}&nbsp;EUR
          </td>
        </tr>
      </tfoot>
    </table>
    <p class="vat-info">U gore navedene iznose uključen je PDV (5%).</p>
  </main>
</template>

<script>
import moment from 'moment'
import { round } from 'lodash'
import { GET_TICKET_SELLERS_REPORT } from '@/graphql/order.graphql'
import { GET_LOGGED_USER } from '@/graphql/user.graphql'
import { CoreEventFeeType, OrderStatusEnum } from '@/types'

export default {
  props: {
    from: {
      type: String,
      default: null,
    },
    to: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      orders: [],
      seller: null,
      reportId: '',
      refundedOrders: [],
      totalSoldCount: 0,
      totalSoldAmount: 0,
      fixedFeeItems: [],
      tisakFeeItems: [],
      totalCoreEventFee: 0,
      totalTisakFee: 0,
      now: new Date(),
    }
  },
  methods: {
    round,
    formatDate(date) {
      return moment(date).format('DD. MM. YYYY')
    },
    formatDateTime(date) {
      return moment(date).format('DD. MM. YYYY HH:mm')
    },
    getYear(date) {
      return moment(date).year()
    },
  },
  apollo: {
    getTicketSellersReport: {
      query: GET_TICKET_SELLERS_REPORT,
      variables() {
        return {
          from: this.from,
          to: this.to,
        }
      },
      fetchPolicy: 'no-cache', // cache for this query only
      manual: true,
      result({ data, loading }) {
        if (loading || !data.getTicketSellersReport) {
          return
        }
        const { getTicketSellersReport } = data
        //add this if you need to hide the gratis
        // .filter(t => !t.buyer || t.buyer.paymentType !== 'FREE')
        const successfulOrders = getTicketSellersReport.filter(o =>
          [OrderStatusEnum.SUCCESSFUL, OrderStatusEnum.REFUND_REQUESTED].includes(o.status),
        )

        this.refundedOrders = getTicketSellersReport.filter(
          o =>
            o.status === OrderStatusEnum.REFUNDED &&
            moment(o.orderRefunded).isBetween(moment(this.from), moment(this.to)),
        )
        getTicketSellersReport.forEach(o => {
          if (
            moment(o.orderCreated).isBetween(moment(this.from), moment(this.to)) &&
            o.status === OrderStatusEnum.REFUNDED
          ) {
            successfulOrders.push(o)
          }
        })

        this.refundedOrders.map(o => {
          this.totalSoldCount -= o.count
          this.totalSoldAmount -= parseFloat(o.totalPrice)
        })
        for (const order of successfulOrders) {
          if (order.buyer && order.buyer.paymentType === 'KEKS10') {
            order.price = (parseFloat(order.price) * 0.9).toFixed(2)
            order.totalPrice = (parseFloat(order.totalPrice) * 0.9).toFixed(2)
          }
          if (order.buyer && order.buyer.paymentType === 'Popust40') {
            order.price = (parseFloat(order.price) * 0.6).toFixed(2)
            order.totalPrice = (parseFloat(order.totalPrice) * 0.6).toFixed(2)
          }
          if (order.buyer && order.buyer.paymentType === 'Popust50') {
            order.price = (parseFloat(order.price) * 0.5).toFixed(2)
            order.totalPrice = (parseFloat(order.totalPrice) * 0.5).toFixed(2)
          }
          if (
            order.buyer &&
            (order.buyer.paymentType === 'TELEGRAM20' || order.buyer.paymentType === 'POPUST20')
          ) {
            order.price = (order.price * 0.8).toFixed(2)
            order.totalPrice = (order.totalPrice * 0.8).toFixed(2)
          }
          if (order.buyer && order.buyer.paymentType === 'FREE') {
            order.price = 0
            order.totalPrice = 0
          }
          if (
            order.buyer &&
            ['CASH20', 'CASH50', 'CARD20', 'CARD50'].includes(order.buyer.paymentType)
          ) {
            if (order.buyer.paymentType.endsWith('20')) {
              order.price = (order.price * 0.8).toFixed(2)
              order.totalPrice = (order.totalPrice * 0.8).toFixed(2)
            } else {
              order.price = (order.price * 0.5).toFixed(2)
              order.totalPrice = (order.totalPrice * 0.5).toFixed(2)
            }
          }
          const existingTicket = this.orders.find(o => o.id === order.id)
          if (existingTicket) {
            existingTicket.totalPrice += parseFloat(order.totalPrice)
            existingTicket.count += order.count
          } else {
            this.orders.push(order)
          }

          this.totalSoldCount += order.count
          this.totalSoldAmount += parseFloat(order.totalPrice)

          if (
            !order.isTisakTicketSeller &&
            order.fiscalisationInfo &&
            order.fiscalisationInfo.useEventFeePerTicket &&
            !order.fiscalisationInfo.fiscalisationError
          ) {
            order.fiscalisationInfo['full_receipt'].items.map(i => {
              if (i.name.includes(CoreEventFeeType.TICKET)) {
                const existingFee = this.fixedFeeItems.find(fee => fee.name === i.name)
                if (existingFee && existingFee.orderId.includes(order.orderId)) {
                  return
                }
                this.totalCoreEventFee += i.price / 100
                if (existingFee) {
                  existingFee.count += i.amt / 1000
                  existingFee.totalPrice += i.price / 100
                  existingFee.orderId.push(order.orderId)
                } else {
                  this.fixedFeeItems.push({
                    orderId: [order.orderId],
                    eventTitle: order.eventTitle,
                    name: i.name,
                    count: i.amt / 1000,
                    totalPrice: i.price / 100,
                    singleItemPrice: i['single_item_price'] / 100,
                  })
                }
              }
            })
          }
          if (order.isTisakTicketSeller && Number(order.tisakFeeTotalWithVat || 0) > 0) {
            const feeName = `Tisak naknada ${Number(order.tisakFeePerTicketWithVat || 0).toFixed(2)}`
            const existingFee = this.tisakFeeItems.find(fee => fee.name === feeName)
            this.totalTisakFee += Number(order.tisakFeeTotalWithVat || 0)
            if (existingFee) {
              existingFee.count += Number(order.count || 0)
              existingFee.totalPrice += Number(order.tisakFeeTotalWithVat || 0)
            } else {
              this.tisakFeeItems.push({
                eventTitle: order.eventTitle,
                name: feeName,
                count: Number(order.count || 0),
                totalPrice: Number(order.tisakFeeTotalWithVat || 0),
                singleItemPrice: Number(order.tisakFeePerTicketWithVat || 0),
              })
            }
          }
        }
      },
    },
    me: {
      query: GET_LOGGED_USER,
      result({ data, loading }) {
        if (!loading && data) {
          const { me: user } = data
          this.seller = user
          const now = new Date()
          this.reportId = `${user.id}${now.getDate()}${now.getMonth() + 1}${
            now.getHours() * 60 + now.getMinutes()
          }`
        }
      },
    },
  },
}
</script>
<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100%;
}

main {
  border-right: 0.11111in dashed #0277bd;
  height: 100%;
  margin-right: 1.333333in;
  padding: 0.33333in 0.22222in 0.33333in 0.44444in;
}

header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.33333in;
}

header img {
  height: 0.33333in;
}

header span {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  text-align: right;
  color: #979797;
}

dl {
  margin-bottom: 0.33333in;
}

dl dt {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.11111in;
  line-height: 120%;
  color: #979797;
  margin-bottom: 0.02777in;
}

dl dd {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  color: #666666;
}

dl dd + dt {
  margin-top: 0.11111in;
}

h1 {
  font-family: 'Raleway', sans-serif;
  font-weight: 800;
  font-size: 0.25in;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #333333;
}

.event-title {
  font-family: 'Raleway', sans-serif;
  font-weight: 800;
  font-size: 0.25in;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #979797;
  margin-bottom: 0.11111in;
}

.sale-period {
  font-family: 'Raleway', sans-serif;
  font-weight: 600;
  font-size: 0.16777in;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #979797;
  margin-bottom: 0.33333in;
}

table {
  width: 100%;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  color: #333333;
  border-collapse: collapse;
}

table thead {
  background: #e6f1f8;
}

table th {
  font-weight: normal;
  color: #0277bd;
}

table th,
table td {
  padding: 0.08333in 0.11111in;
}

table th:nth-child(-n + 3),
table tbody td:nth-child(-n + 3) {
  text-align: left;
}

table th:nth-child(n + 4),
table tbody td:nth-child(n + 4) {
  text-align: right;
}

table tfoot {
  background: #e6f1f8;
}

table tfoot td {
  color: #0277bd;
  text-align: right;
}

table tr:nth-child(even) {
  background: #f5f5f5;
}

.vat-info {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.11111in;
  line-height: 120%;
  color: #666666;
  margin-top: 0.33333in;
  text-align: right;
}
</style>
